const relativeFormatter = new Intl.RelativeTimeFormat("en", { numeric: "auto" });

const units = [
  { unit: "year", seconds: 60 * 60 * 24 * 365 },
  { unit: "month", seconds: 60 * 60 * 24 * 30 },
  { unit: "day", seconds: 60 * 60 * 24 },
  { unit: "hour", seconds: 60 * 60 },
  { unit: "minute", seconds: 60 },
  { unit: "second", seconds: 1 }
] as const;

export function formatRelativeTime(isoDate: string) {
  const deltaSeconds = Math.round((new Date(isoDate).getTime() - Date.now()) / 1000);
  const unit = units.find((candidate) => Math.abs(deltaSeconds) >= candidate.seconds) ?? units[units.length - 1];
  const value = Math.round(deltaSeconds / unit.seconds);

  return relativeFormatter.format(value, unit.unit);
}
